function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m10.988 22.645 3.754-3.888 3.12 3.233 3.485-3.608-1.979-2.049h5.517v5.714l-1.978-2.049-5.044 5.224-3.12-3.232-2.732 2.828c1.24 1.932 3.143 3.304 5.323 3.838a8.563 8.563 0 0 0 6.418-.964c1.943-1.154 3.391-3.029 4.05-5.247a9.441 9.441 0 0 0-.504-6.696c-.983-2.085-2.693-3.706-4.786-4.533a8.545 8.545 0 0 0-6.485.078c-2.074.877-3.748 2.537-4.684 4.645a9.444 9.444 0 0 0-.355 6.707v-.001zm-1.697 1.78-.01-.01.004-.005a11.736 11.736 0 0 1-.951-4.648c0-6.312 4.94-11.429 11.034-11.429s11.035 5.117 11.035 11.429-4.94 11.428-11.035 11.428c-4.491 0-8.353-2.777-10.077-6.764z",
  fill: "#fff"
});

function SvgIconGraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGraph);
export default __webpack_public_path__ + "static/media/icon-graph.adfb6238.svg";
export { ForwardRef as ReactComponent };